var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "unpackgameInstanceItem-div" },
    [
      _c(
        "div",
        { ref: "unpackgameInstanceItem_dialog_ui" },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.showDialog,
                "close-on-click-modal": false,
                "show-close": false,
                "custom-class": "unpackgameInstanceItem-dialog",
                top: _vm.$screen.mobile ? "20%" : "5%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showDialog = $event
                },
                close: _vm.onCloseHand,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "unpackgameInstanceItem-container animate__animated animate__zoomIn animate__faster",
                },
                [
                  _c(
                    "div",
                    { staticClass: "pic-item" },
                    [
                      _c(
                        "el-image",
                        {
                          staticClass:
                            "unpackgameInstanceItem-border goods-visible-faguang",
                          attrs: { src: _vm.unpackgameInstanceItemBorder },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "image-slot",
                              attrs: { slot: "placeholder" },
                              slot: "placeholder",
                            },
                            [
                              _vm._v(" 加载中"),
                              _c("span", { staticClass: "dot" }, [
                                _vm._v("..."),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "el-image",
                        {
                          staticClass: "unpackgameInstanceItem-bg",
                          attrs: { src: _vm.unpackgameInstanceItemBg },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "image-slot",
                              attrs: { slot: "placeholder" },
                              slot: "placeholder",
                            },
                            [
                              _vm._v(" 加载中"),
                              _c("span", { staticClass: "dot" }, [
                                _vm._v("..."),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "cumulative_bonus_pic animate__animated animate__flipInY",
                        },
                        [
                          _c(
                            "el-image",
                            {
                              staticClass: "goods-visible-faguang",
                              attrs: {
                                src:
                                  _vm.type == "accumulate"
                                    ? _vm.cumulative_bonus_Pic
                                    : _vm.average_Pic,
                                fit: "cover",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "image-slot",
                                  attrs: { slot: "placeholder" },
                                  slot: "placeholder",
                                },
                                [
                                  _vm._v(" 加载中"),
                                  _c("span", { staticClass: "dot" }, [
                                    _vm._v("..."),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.type == "accumulate"
                    ? _c("div", {
                        staticClass: "close-btn",
                        on: { click: _vm.onCloseHand },
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "send-goods-star" }),
                  _c("div", { staticClass: "send-goods-star2" }),
                  _c(
                    "div",
                    { staticClass: "unpackgameInstance-item" },
                    [
                      _c("caseDetail-item", {
                        attrs: {
                          caseDetailId: _vm.gameInstanceId,
                          muxiangCaseId: _vm.muxiangCaseId,
                          isGameInstanceCase: true,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _c("c-RewardModal", {
        ref: "case_reward_ui_gameInstance",
        attrs: { type: _vm.type },
        on: { "on-onRewardModalCloseHandle": _vm.onRewardModalCloseHandle },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }